import React from 'react';

const TabSwitcher = ({ 
  tabs = [], 
  activeTab, 
  onTabChange, 
  containerStyle = {},
  tabsListStyle = {},
  getTabTriggerStyle = () => ({}),
  iconStyle = {},
  labelStyle = {},
  tabContentStyle = {},
  children 
}) => {
  return (
    <div style={containerStyle}>

      {/* Tab Navigation */}
      <div style={tabsListStyle}>
        
        {tabs.map((tab) => {
          const isActive = activeTab === tab.value;

          return (
            <button
              key={tab.value}
              onClick={() => onTabChange(tab.value)}
              style={getTabTriggerStyle(isActive)}
              title={tab.description}
              onMouseEnter={(e) => {
                if (!isActive) {
                  e.currentTarget.style.backgroundColor = '#f3f4f6';
                  e.currentTarget.style.color = '#374151';
                }
              }}
              onMouseLeave={(e) => {
                if (!isActive) {
                  e.currentTarget.style.backgroundColor = 'transparent';
                  e.currentTarget.style.color = '#6b7280';
                }
              }}
            >
              <span style={labelStyle}>{tab.label}</span>
            </button>
          );
        })}
      </div>

      {/* Content Area */}
      <div style={tabContentStyle}>
        {children}
      </div>
    </div>
  );
};

export default TabSwitcher;
